import { FontWeights, memoizeFunction, mergeStyles } from "@fluentui/react";
import { Colors } from "@ms/uno-constants/lib/local/Colors";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
import { flexParent } from "../../../utilities/Mixin.styles";
import { highContrastColor } from "../../../utilities/HighContrast.styles";
import { isDarkTheme, isDarkOrHcTheme } from "../../../utilities/ThemeUtilities";
/**
 * Get the styles for the ICalendar Deprecation Banner
 * @param theme Planner Theme
 */ export const getICalendarDeprecationBannerStyles = memoizeFunction((theme)=>{
    const message = [
        flexParent("row"),
        {
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "100%",
            height: "100%",
            minHeight: "44px",
            margin: "0",
            padding: "0"
        }
    ];
    const boldText = {
        fontWeight: FontWeights.semibold,
        marginRight: "6px"
    };
    return {
        message,
        boldText
    };
});
/**
 * Get the class names for the ICalendar Deprecation Banner
 * @param theme Planner Theme
 */ export const getICalendarDeprecationBannerClassNames = memoizeFunction((theme)=>{
    const styles = getICalendarDeprecationBannerStyles(theme);
    return {
        message: mergeStyles("iCalendarDeprecationBannerMessage", styles.message),
        boldText: mergeStyles("iCalendarDeprecationBannerBoldText", styles.boldText)
    };
});
/**
 * Styles for the ICalendar Deprecation Banner MessageBar container
 * Creates a purple-themed banner similar to PlannerPromotionalBanner
 */ export const iCalendarDeprecationBannerContainerStyles = memoizeFunction((theme)=>{
    const isHighContrast = theme.name === PlannerTheme.HighContrast;
    const isDark = isDarkTheme(theme);
    const isDarkOrHc = isDarkOrHcTheme(theme);
    const root = [
        highContrastColor(),
        {
            background: isDarkOrHc ? "linear-gradient(93.07deg, #383966 19.49%, #63276D 89.45%)" : "linear-gradient(93.89deg, #DCDFFA 19.24%, #FCF6FD 85.39%)",
            fontSize: "12px",
            lineHeight: "16px",
            minHeight: "44px",
            height: "44px",
            border: isDarkOrHc ? "1px solid #7579EB" : "1px solid #C5CBFA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 12px",
            ".ms-MessageBar-content": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                margin: "0",
                padding: "0"
            },
            ".ms-MessageBar-text": {
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                width: "100%",
                height: "100%",
                margin: "0",
                padding: "0"
            },
            ".ms-MessageBar-innerText": {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0",
                padding: "0"
            },
            ".ms-MessageBar-innerText > span": {
                display: "flex",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                margin: "0",
                padding: "0"
            }
        }
    ];
    // Hide the warning icon to match promotional banner style
    const iconContainer = {
        display: "none"
    };
    const dismissButtonColor = isHighContrast ? Colors.White : isDark ? "#D6D6D6" : "#5B5FC7";
    const dismissal = {
        height: "auto",
        ".ms-Button-flexContainer": {
            height: "auto"
        },
        ".ms-Button-icon": {
            color: dismissButtonColor
        }
    };
    return {
        root,
        iconContainer,
        dismissal
    };
});
